import { RankedTester, rankWith, uiTypeIs } from "@jsonforms/core";

export const groupLayoutTester: RankedTester = rankWith(3, uiTypeIs("Group"));
